import { makeStyles } from '@material-ui/core';
import { DRAWER_WIDTH, MOBILE_TOOLBAR_HEIGHT } from '../../neo-wrapper/neo-wrapper.styles';

const UseWelcomeNavbarStyles = makeStyles((theme) => {
  const mobileBreakpoint = theme.breakpoints.down('sm');

  return ({
    welcome__navigation: {
      display: 'flex',
      justifyContent: 'space-between',
      margin: '40px 0px',
      [mobileBreakpoint]: {
        justifyContent: 'flex-end',
      },

      '& > button': {
        border: 'none',
        padding: '8px 50px',
        borderRadius: '5px',
        cursor: 'pointer',
        [mobileBreakpoint]: {
          padding: '8px 30px',
          marginRight: '10px'
        }
      },
    },
    welcome__navigation__align__right: {
      justifyContent: 'flex-end'
    },
    welcome__navigation__back: {
      boxShadow: '0 0 0 2px inset var(--azure)',
      backgroundColor: 'var(--white)',
      color: 'var(--azure)'
    },
    welcome__navigation__next: {
      color: 'var(--white)',
      backgroundColor: 'var(--teal-blue)',
      '&:disabled': {
        backgroundColor: 'var(--pale-grey-one)',
        color: 'var(--neutrals-black)',
        opacity: '.38'
      }
    },
    appbar: {
      maxWidth: '100%',
      backgroundColor: 'none',
      [theme.breakpoints.up('md')]: {
        width: `calc(100% - ${DRAWER_WIDTH}px)`,
        marginLeft: DRAWER_WIDTH
      }
    },
    bottomAppBar: {
      top: 'auto',
      bottom: 0
    },
    bottomToolbar: {
      display: 'flex',
      flexGrow: 1,
      [theme.breakpoints.down('md')]: {
        height: MOBILE_TOOLBAR_HEIGHT
      }
    },
  });
});

export default UseWelcomeNavbarStyles;
